import styles from './styles.module.scss'
import FacebookIcon from '/public/icons/icon-facebook.svg'
import InstagramIcon from '/public/icons/icon-instagram.svg'
import { withModifiers } from '../../helpers/withModifiers'
import InstagramIconHover from '/public/icons/icon-instagram-hover.svg'
import LinkedinIcon from '/public/icons/icon-linkedin.svg'
import TwitterIcon from '/public/icons/icon-x.svg'
import YoutubeIcon from '/public/icons/icon-youtube.svg'
import { useResponsive } from '../../../providers/ResponsiveContext'
import LazyImage from '../../elements/LazyImage'

const SocialConnect = ({ variant = [] }) => {
  const { isMobile } = useResponsive()

  return (
    <div className={withModifiers('social', [...variant], styles)}>
      <a
        href="https://www.instagram.com/sxmsir"
        target="_blank"
        aria-label="Instagram Page"
        className={withModifiers('social__icon', ['instagram'], styles)}
        rel="noreferrer"
      >
        <InstagramIcon
          alt="Instagram Icon"
          width={isMobile ? 15 : 18}
          height={isMobile ? 15 : 18}
        />

        <InstagramIconHover
          className={styles.social__ighover}
          width={isMobile ? 15 : 18}
          height={isMobile ? 15 : 18}
        />

        <LazyImage
          layout="fill"
          alt="Instagram Icon background"
          src="/images/image-bg-instagram.jpeg"
          className={styles.social__background}
        />

        <div className={styles.social__mask}></div>
      </a>

      <a
        href="https://www.facebook.com/stmartinsothebysrealty/"
        target="_blank"
        aria-label="Facebook Page"
        className={withModifiers('social__icon', ['facebook'], styles)}
        rel="noreferrer"
      >
        <FacebookIcon
          alt="Facebook Icon"
          width={isMobile ? 9 : 11}
          height={isMobile ? 20 : 23}
        />
      </a>

      <a
        href="https://twitter.com/SXMSIR"
        target="_blank"
        aria-label="Twitter Page"
        className={withModifiers('social__icon', ['twitter'], styles)}
        rel="noreferrer"
      >
        <TwitterIcon
          alt="Twitter Icon"
          width={isMobile ? 18 : 21}
          height={isMobile ? 14 : 17}
        />
      </a>

      <a
        href="https://www.linkedin.com/company/stmartinsothebysrealty"
        target="_blank"
        aria-label="Linkedin Page"
        className={withModifiers('social__icon', ['linkedin'], styles)}
        rel="noreferrer"
      >
        <LinkedinIcon
          alt="LinkedIn Icon"
          width={isMobile ? 15 : 16}
          height={isMobile ? 14 : 16}
        />
      </a>

      <a
        href="https://www.youtube.com/channel/UCjnr48kipvnQZnxPiSlluLQ"
        target="_blank"
        aria-label="Youtube channel"
        className={withModifiers('social__icon', ['youtube'], styles)}
        rel="noreferrer"
      >
        <YoutubeIcon
          alt="Youtube Icon"
          width={isMobile ? 20 : 24}
          height={isMobile ? 33 : 18}
        />
      </a>
    </div>
  )
}

export default SocialConnect
